module.exports = __webpack_public_path__ + "img/img23.a508e200.svg";